import messages from './messages.json';
import createMessage from './create-message.json';
import messageSteps from './message-steps.json';

export default {
  messages,
  createMessage,
  messageSteps,
};
